
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'supplierinvoiceIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'supplierinvoice',
				windowName: '供应商发票',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
